module.exports = __webpack_public_path__ + "static/docker-deep-dive-4270d75eddc66e83f6df41b70e06dae9.png";